import {Mic} from 'lucide-react';

const MultipleLabView = ({transcriptions, transcriptionsEndRef}) => (
    <>
        {transcriptions.map((t) => (
            <div key={t.id} className="glass-panel rounded-xl p-4 animate-slide-up">
                <div className="flex items-start gap-3">
                    <div
                        className="w-10 h-10 bg-accent-secondary  rounded-full flex items-center justify-center flex-shrink-0">
                        <Mic className="w-5 h-5 text-white"/>
                    </div>

                    <div className="flex-1 min-w-0">
                        <div className="text-white leading-relaxed mb-2">
                            {t.transcript}
                        </div>

                        {t.translation && (
                            <div
                                className="text-sm text-purple-300 italic border-l-2 border-purple-500/50 pl-3 py-1 mt-2">
                                <span className="text-xs text-purple-400/70 block mb-1">Translation:</span>
                                {t.translation}
                            </div>
                        )}

                        <div className="flex items-center justify-between mt-3">
                            <div className="text-xs text-zinc-500">
                                {new Date(t.timestamp).toLocaleTimeString()}
                            </div>

                            <div className="flex items-center gap-2">
                                {/*{t.confidence < 0.8 ? (*/}
                                {/*    <div className="text-xs text-yellow-400">*/}
                                {/*        ⚠️ {(t.confidence * 100).toFixed(0)}%*/}
                                {/*    </div>*/}
                                {/*) : (*/}
                                {/*    <div className="text-xs text-teal-500">*/}
                                {/*        ✓ {(t.confidence * 100).toFixed(0)}%*/}
                                {/*    </div>*/}
                                {/*)}*/}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ))}
        <div ref={transcriptionsEndRef}/>
    </>
)

export default MultipleLabView;